import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import {
  GetPayrollAnomalyDetailsQuery,
  GetPayrollAnomalyDetailsQueryVariables,
} from "generated/graphql";

export const usePayrollAnomalyDetails = (netEarningsFileId: string) => {
  const { data, loading, error } = useQuery<
    GetPayrollAnomalyDetailsQuery,
    GetPayrollAnomalyDetailsQueryVariables
  >(
    queries.GET_PAYROLL_ANOMALY_DETAILS,
    {
      variables: {
        id: netEarningsFileId,
      },
    }
  );

  return {
    payrollAnomalyDetails: data?.payrollJournalFile,
    loading,
    error,
  };
};

